//---------- Stciky Header ----------//
document.addEventListener("DOMContentLoaded", () => {
  var didScroll;
  var lastScrollTop = 0;
  var delta = 4;
  var navbarHeight = $(".site-header").outerHeight();

  $(window).on("scroll", function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(window).scrollTop();
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // Handle the header animations
    handleHeaderAnimation(st);

    // Handle the secondary header positioning
    handleSecondaryHeaderPosition(st);

    lastScrollTop = st;
  }

  function handleHeaderAnimation(scrollTop) {
    if (scrollTop > lastScrollTop && scrollTop > navbarHeight) {
      // Scrolling down
      $(".site-header").removeClass("nav-down").addClass("nav-up");
    } else {
      // Scrolling up
      if (
        scrollTop + $(window).height() < $(document).height() &&
        scrollTop > navbarHeight
      ) {
        $(".site-header").removeClass("nav-up").addClass("nav-down");
      }
    }

    if (scrollTop >= 200) {
      $(".site-header").addClass("nav-hiding");
    } else {
      $(".site-header").removeClass("nav-hiding");
    }

    if (scrollTop < delta) {
      $(".site-header").removeClass("nav-up nav-down");
    }
  }

  // for sticky header
  function handleSecondaryHeaderPosition(scrollTop) {
    if ($(".site-header").hasClass("nav-down")) {
      $(".secondary-header").addClass("secondary-header-active");
    } else {
      $(".secondary-header").removeClass("secondary-header-active");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // homepage
  // --------------- Normal slider ---------------//
  var splideSelector = document.querySelector(".swiper-slider");
  if (splideSelector) {
    new Splide(splideSelector, {
      perPage: 3,
      perMove: 1,
      arrows: true,
      omitEnd: true,
      pagination: false,
      gap: 20,
      breakpoints: {
        768: {
          perPage: 1,
        },
      },
    }).mount();
  }

  function initToggleElements(selector) {
    const items = document.querySelectorAll(selector + " li");

    items.forEach((item) => {
      if (!item.classList.contains("tab-active")) {
        item.style.display = "none";
      }
    });

    items.forEach((item) => {
      item.addEventListener("click", function () {
        if (this.classList.contains("tab-active")) {
          items.forEach((i) => {
            if (i !== this) {
              i.style.display = i.style.display === "flex" ? "flex" : "none";
            }
          });
        } else {
          items.forEach((i) => {
            i.style.display = "none";
            i.classList.remove("tab-active");
          });

          this.style.display = "flex";
          this.classList.add("tab-active");
        }
      });
    });
  }

  function checkScreenSize() {
    if (window.innerWidth < 768) {
      initToggleElements("#toggle-elements");
      initToggleElements("#toggle-elements-contact");
    }
  }

  window.addEventListener("resize", checkScreenSize);
  const toggleElements = document.querySelector("#toggle-elements");
  const liItems = document.querySelectorAll(".tag-container li");
  const list = document.querySelector(".tag-container");
  const span = document.querySelector("#toggle-elements");
  const listContainer = document.querySelector(".tag-container");

  function toggleForMobile() {
    if (window.innerWidth < 768) {
      liItems.forEach(function (li) {
        li.style.display = "none";
      });

      toggleElements.addEventListener("click", function () {
        liItems.forEach(function (li) {
          li.style.display = "block";
          list.style.display = "block";
        });

        listContainer.classList.add("tabs-open");
      });

      liItems.forEach(function (li) {
        li.addEventListener("click", function () {
          span.textContent = this.textContent;
          list.style.display = "none";

          liItems.forEach((item) => {
            item.classList.remove("tab-active");
            item.style.display = "none";
          });

          this.classList.add("tab-active");
          this.style.display = "flex";

          listContainer.classList.remove("tabs-open");
        });
      });
    } else {
      if (toggleElements) {
        toggleElements.style.display = "none";
      }
    }
  }

  toggleForMobile();

  window.addEventListener("resize", function () {
    toggleForMobile();
  });

  // --------------- video pop-up ---------------//
  $(document).ready(function () {
    $(".popup-youtube").magnificPopup({
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
      callbacks: {
        close: function () {
          console.log("Popup closed, triggering body click...");
          $("body").trigger("click");
        },
      },
    });
  });
});

// --------------- financial-governance ---------------//
// page heading
if (document.body.classList.contains("page-template-template-financials")) {
  document.querySelectorAll(".tab-menu li").forEach(function (menu) {
    menu.addEventListener("click", function () {
      document.getElementById("active-tab-title").innerText = this.innerText;
    });
  });
}
// view more btn
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("page-template-template-financials")) {
    const reportContainers = document.querySelectorAll(
      ".report-card-container"
    );

    reportContainers.forEach((container, index) => {
      const cards = container.querySelectorAll(".view-more-card");
      const viewMoreBtn = document.getElementById(`viewMoreBtn${index}`);
      const initialDisplayCount = 6;
      let currentDisplayCount = initialDisplayCount;

      cards.forEach((card, index) => {
        if (index >= initialDisplayCount) {
          card.style.display = "none";
        }
      });

      viewMoreBtn.addEventListener("click", function () {
        for (let i = currentDisplayCount; i < currentDisplayCount + 6; i++) {
          if (i < cards.length) {
            cards[i].style.display = "block";
          }
        }

        currentDisplayCount += 6;

        if (currentDisplayCount >= cards.length) {
          viewMoreBtn.textContent = "No More Posts";
          viewMoreBtn.disabled = true;
        }
      });
    });
  }
});

// --------------- contact ---------------//
// copy to clipboard
$(document).ready(function () {
  $(".copy").click(function (event) {
    event.preventDefault();
    var email = $(this).siblings("p").text();
    CopyToClipboard(email, true, "Copied");
  });
});

function CopyToClipboard(value, showNotification, notificationText) {
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val(value).select();
  document.execCommand("copy");
  $temp.remove();

  if (typeof showNotification === "undefined") {
    showNotification = true;
  }
  if (typeof notificationText === "undefined") {
    notificationText = "Copied to clipboard";
  }

  var notificationTag = $("div.copy-notification");
  if (showNotification && notificationTag.length == 0) {
    notificationTag = $("<div/>", {
      class: "copy-notification",
      text: notificationText,
    });
    $("body").append(notificationTag);

    notificationTag.fadeIn("slow", function () {
      setTimeout(function () {
        notificationTag.fadeOut("slow", function () {
          notificationTag.remove();
        });
      }, 1000);
    });
  }
}
// --------------- team ---------------//
// spliders
document.addEventListener("DOMContentLoaded", function () {
  const teamSliders = document.querySelectorAll(".team-slider");

  if (teamSliders.length) {
    teamSliders.forEach(function (sliderElement) {
      const splide = new Splide(sliderElement, {
        type: "loop",
        autoplay: false,
        perPage: 3,
        focus: "center",
        gap: "10px",
        pagination: false,
        arrows: false,
        breakpoints: {
          768: {
            gap: "10px",
          },
        },
      }).mount();

      let scrollSpeed = 1.5;
      let animationFrame;

      function smoothScroll() {
        splide.Components.Move.translate(
          splide.Components.Move.getPosition() - scrollSpeed
        );
        animationFrame = requestAnimationFrame(smoothScroll);
      }

      smoothScroll();

      sliderElement.addEventListener("mouseenter", () => {
        cancelAnimationFrame(animationFrame);
      });

      sliderElement.addEventListener("mouseleave", () => {
        smoothScroll();
      });
    });
  }
});

// Pop-up
document.addEventListener("DOMContentLoaded", function () {
  const popUpContent = document.querySelectorAll(".pop-content-wrap a");
  const popups = document.querySelectorAll(".popup");
  const overlay = document.querySelector(".overlay");
  const closeIcons = document.querySelectorAll(".close-icon svg");

  popUpContent.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      let popupToShow;
      const dataId = this.getAttribute("data-id");
      const dataIdTwo = this.getAttribute("data-id-two");

      if (dataId) {
        popupToShow = document.querySelector(`#popup-${dataId}`);
      } else if (dataIdTwo) {
        popupToShow = document.querySelector(`#popup-two-${dataIdTwo}`);
      }

      if (popupToShow) {
        popupToShow.style.display = "block";
        if (overlay) {
          overlay.style.display = "block";
        }
      }
    });
  });

  closeIcons.forEach((icon) => {
    icon.addEventListener("click", function () {
      const popupToClose = this.closest(".popup");
      if (popupToClose) {
        popupToClose.style.display = "none";
        if (overlay) {
          overlay.style.display = "none";
        }
      }
    });
  });

  if (overlay) {
    // Check if overlay exists before adding event listener
    overlay.addEventListener("click", function () {
      popups.forEach((popup) => {
        popup.style.display = "none";
      });
      overlay.style.display = "none";
    });
  }
});

// swiper splide

document.addEventListener("DOMContentLoaded", function () {
  const sliders = [".swiper-slider-two", ".swiper-slider-three"];
  const breakpoint = 768;

  function initializeSlider(sliderElement) {
    if (window.innerWidth <= breakpoint) {
      if (!sliderElement.classList.contains("initialized")) {
        new Splide(sliderElement, {
          perPage: 1,
          perMove: 1,
          pagination: false,
          arrows: true,
          speed: 800,
          easing: "ease",
        }).mount();
        sliderElement.classList.add("initialized");
      }
    } else {
      if (sliderElement.classList.contains("initialized")) {
        sliderElement.classList.remove("initialized");
      }
    }
  }

  function initAllSliders() {
    sliders.forEach((selector) => {
      const sliderElement = document.querySelector(selector);
      if (sliderElement) {
        initializeSlider(sliderElement);
      }
    });
  }

  initAllSliders();
  window.addEventListener("resize", initAllSliders);
});

// blogs
document.addEventListener("DOMContentLoaded", function () {
  let page = 1; // Start with the first page
  const loadMoreButton = document.getElementById("load-more");

  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", function (event) {
      event.preventDefault();

      page++; // Increment the page count

      fetch(
        ajax_obj.ajax_url +
          "?action=load_more_posts&page=" +
          page +
          "&nonce=" +
          ajax_obj.nonce +
          "&post_type=" +
          loadMoreButton.dataset.postType
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.text();
        })
        .then((data) => {
          const posts = data.trim();
          const postList = document.querySelector(".post-list");

          if (postList) {
            postList.insertAdjacentHTML("beforeend", posts);
          }

          // Check if less than 3 posts were returned
          if ((posts.match(/<a class="blog-post"/g) || []).length < 3) {
            loadMoreButton.textContent = "No More Posts";
            loadMoreButton.disabled = true; // Disable button if no more posts
          }
        })
        .catch((error) => console.error("Error:", error));
    });
  }
});

// donation section smooth scroll
document.querySelectorAll(".donation-btn").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const donationSection = document.getElementById("donation");
    if (donationSection) {
      donationSection.scrollIntoView({
        behavior: "smooth",
      });
    }
  });
});

// education inner page
function activateTabById(id) {
  document.querySelectorAll(".tab-wrapper").forEach(function (tabWrapper) {
    const tabBlocks = tabWrapper.querySelectorAll(".tab-block");

    tabBlocks.forEach(function (tabBlock) {
      const tabMenuItems = tabBlock.querySelectorAll(".tab-menu li");
      const tabContentItems = tabBlock.querySelectorAll(
        ".tab-content > .tab-items"
      );

      tabContentItems.forEach((content) => {
        content.style.display = content.id === id ? "block" : "none";
      });

      tabMenuItems.forEach((menu) => {
        const menuTab =
          tabContentItems[
            Array.from(tabContentItems).indexOf(document.getElementById(id))
          ];
        menu.classList.toggle(
          "tab-active",
          menu.getAttribute("data-tab") === menuTab?.getAttribute("data-tab")
        );
      });
    });
  });
}

function activateTabFromHash() {
  const hash = window.location.hash.substring(1);
  if (hash) {
    activateTabById(hash);
  }
}

window.addEventListener("DOMContentLoaded", activateTabFromHash);

window.addEventListener("hashchange", activateTabFromHash);

//Number Count Animation
const counters = document.querySelectorAll(".counter");

const startCounting = (counter) => {
  const numberElement = counter.querySelector(".number");

  // Check if the .number element exists
  if (numberElement) {
    const target = +counter.getAttribute("data-target");
    const startValue = target > 100 ? target - 20 : 0; // Start from 10 less if target > 100
    const increment = (target - startValue) / 200; // Adjust increment based on start value

    numberElement.innerText = Math.floor(startValue); // Set initial value to startValue

    const updateCounter = () => {
      const currentCount = +numberElement.innerText;

      if (currentCount < target) {
        numberElement.innerText = `${Math.ceil(currentCount + increment)}`;
        setTimeout(updateCounter, 50);
      } else {
        numberElement.innerText = target.toLocaleString();
      }
    };

    updateCounter();
  } else {
    console.warn("No .number element found in this counter.");
  }
};

const observer = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        startCounting(entry.target);
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.5 }
);

counters.forEach((counter) => {
  observer.observe(counter);
});

function setupDropdown(menuItemClass) {
  const menuItems = document.querySelectorAll(`.${menuItemClass}`);

  menuItems.forEach((menuItem) => {
    const subMenu = menuItem.querySelector(".sub-menu");

    if (subMenu) {
      // Show submenu on hover
      menuItem.addEventListener("mouseenter", function () {
        subMenu.classList.add("show");
      });

      // Hide submenu when mouse leaves
      menuItem.addEventListener("mouseleave", function () {
        subMenu.classList.remove("show");
      });
    }
  });
}

setupDropdown("menu-item-has-children");

//Health : Our comprehensive program includes.
document.addEventListener("DOMContentLoaded", function () {
  const colors = [
    "#F58130",
    "#E9EBF5",
    "#FAC097",
    "#FFD666",
    "#223C97",
    "#D3D8EA",
  ];

  const items = document.querySelectorAll(".comprehensive-program-items");

  items.forEach((item, index) => {
    const color = colors[index % colors.length];
    item.style.backgroundColor = color;

    if (index === 0) {
      item.style.color = "#ffffff";
    } else {
      const rgb = hexToRgb(color);

      const brightness = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;

      item.style.color = brightness < 128 ? "#ffffff" : "#000964";
    }
  });

  function hexToRgb(hex) {
    const bigint = parseInt(hex.slice(1), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  }
});

//Youth : Our comprehensive program includes.
document.addEventListener("DOMContentLoaded", function () {
  const colors = [
    "#F58130",
    "#E9EBF5",
    "#FAC097",
    "#FFD666",
    "#223C97",
    "#D3D8EA",
  ];

  const items = document.querySelectorAll(".youth-comprehensive-program-items");

  items.forEach((item, index) => {
    const color = colors[index % colors.length];
    item.style.backgroundColor = color;

    const svgArrow = item.querySelector(".down-arrow svg path");

    if (index === 0) {
      item.style.color = "#ffffff";
      if (svgArrow) svgArrow.setAttribute("stroke", "#ffffff");
    } else {
      const rgb = hexToRgb(color);
      const brightness = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;

      const textColor = brightness < 128 ? "#ffffff" : "#000964";
      item.style.color = textColor;

      if (svgArrow) svgArrow.setAttribute("stroke", textColor);
    }
  });

  function hexToRgb(hex) {
    const bigint = parseInt(hex.slice(1), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  }
});

let openMenu = null;
const headers = document.querySelectorAll(".footerMenu");

// Initially open the first menu
if (headers.length > 0) {
  const firstUl = headers[0].nextElementSibling;
  if (firstUl && firstUl.tagName === "UL") {
    firstUl.style.maxHeight = firstUl.scrollHeight + "px";
    openMenu = firstUl;
  }
}

headers.forEach((header) => {
  header.addEventListener("click", function () {
    const ulElement = this.nextElementSibling;

    if (ulElement && ulElement.tagName === "UL") {
      if (openMenu && openMenu !== ulElement) {
        openMenu.style.maxHeight = null;
      }

      if (ulElement.style.maxHeight) {
        ulElement.style.maxHeight = null;
      } else {
        ulElement.style.maxHeight = ulElement.scrollHeight + "px";
        openMenu = ulElement;
      }
    }
  });
});

// // mobile header

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".mobile-dropdown").forEach((dropdown) => {
//     dropdown.addEventListener("click", function (event) {
//       event.preventDefault();

//       const subMenu = this.querySelector(".sub-menu");

//       document.querySelectorAll(".sub-menu").forEach((menu) => {
//         if (menu !== subMenu) {
//           menu.style.height = "0px";
//           menu.style.padding = "0px";
//         }
//       });

//       if (subMenu) {
//         if (subMenu.style.height === "" || subMenu.style.height === "0px") {
//           subMenu.style.height = `${subMenu.scrollHeight}px`;
//           subMenu.style.padding = "";
//         } else {
//           subMenu.style.height = "0px";
//           subMenu.style.padding = "0px";
//         }
//       }
//     });
//   });

//   $(".sub-menu li a").on("click", function (e) {
//     e.stopPropagation();
//     var href = $(this).attr("href");
//     if (href) {
//       window.location = href;
//     }
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".mobile-dropdown").forEach((dropdown) => {
//     dropdown.addEventListener("click", function (event) {
//       event.preventDefault();

//       const subMenu = this.querySelector(".sub-menu");

//       // Close all other sub-menus
//       document.querySelectorAll(".sub-menu").forEach((menu) => {
//         if (menu !== subMenu) {
//           menu.style.height = "0px";
//           menu.style.padding = "0px";
//         }
//       });

//       // Toggle the current sub-menu
//       if (subMenu) {
//         if (subMenu.style.height === "" || subMenu.style.height === "0px") {
//           subMenu.style.height = `${subMenu.scrollHeight}px`;
//           subMenu.style.padding = "";
//         } else {
//           subMenu.style.height = "0px";
//           subMenu.style.padding = "0px";
//         }
//       }
//     });
//   });

//   // Handle link clicks in sub-menu without preventing navigation
//   document.querySelectorAll(".sub-menu li a").forEach((link) => {
//     link.addEventListener("click", function (event) {
//       event.stopPropagation(); // Prevent the dropdown toggle but allow link navigation
//       const href = this.getAttribute("href");

//       if (href) {
//         // Check if the link has target="_blank" and open in a new tab
//         if (this.getAttribute("target") === "_blank") {
//           window.open(href, "_blank");
//         } else {
//           window.location.href = href;
//         }
//       }
//     });
//   });
// });

//Homepage client slider
document.addEventListener("DOMContentLoaded", function () {
  const teamSliders = document.querySelectorAll(".homepage-clients");
  if (teamSliders.length) {
    teamSliders.forEach(function (sliderElement) {
      new Splide(sliderElement, {
        type: "loop",
        perPage: 5,
        focus: "center",
        pagination: false,
        arrows: false,
        breakpoints: {
          768: {
            gap: "10px",
          },
        },
        autoScroll: {
          speed: 1,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      }).mount({ AutoScroll: window.splide.Extensions.AutoScroll });
    });
  }
});

//Accordion
document.querySelectorAll(".accordion-title").forEach((title) => {
  title.addEventListener("click", () => {
    const content = title.nextElementSibling;

    if (content.classList.contains("expanded")) {
      content.style.height = `${content.scrollHeight}px`;
      setTimeout(() => (content.style.height = "0"), 0);
    } else {
      content.style.height = `${content.scrollHeight}px`;
    }

    content.classList.toggle("expanded");
  });
});

//Youth / Health Dropdown menu
document.addEventListener("DOMContentLoaded", () => {
  const youthTabSectionMobileDropdownSelect = document.getElementById(
    "youth-tab-section-mobile-dropdown-Select"
  );
  const tabMenuItems = document.querySelectorAll(".tab-menu li");

  if (youthTabSectionMobileDropdownSelect) {
    youthTabSectionMobileDropdownSelect.addEventListener("click", () => {
      youthTabSectionMobileDropdownSelect.classList.toggle("show-tab-menu");
    });

    tabMenuItems.forEach((item) => {
      item.addEventListener("click", () => {
        youthTabSectionMobileDropdownSelect.innerHTML = `${item.textContent} <svg xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11" fill="none"><path d="M0 1.5C0.954 1.5 2.37857 2.32462 3.57429 3.15937C5.11714 4.23262 6.46329 5.51512 7.49057 6.9855C8.26071 8.088 9 9.4245 9 10.5M9 10.5C9 9.4245 9.73929 8.08687 10.5094 6.9855C11.538 5.51512 12.8841 4.23262 14.4244 3.15937C15.6214 2.32462 17.0486 1.5 18 1.5M9 10.5V10.1991" stroke="#000964" stroke-width="1.5"/></svg>`;

        youthTabSectionMobileDropdownSelect.classList.remove("show-tab-menu");
      });
    });
  }
});

//About section scroll
document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".menu-wrap .abt-sec-scroll");

  const headerHeight = document.querySelector(".site-header").offsetHeight;

  menuItems.forEach((item) => {
    item.addEventListener("click", function () {
      const sectionId = this.getAttribute("data-section");
      const section = document.getElementById(sectionId);

      if (section) {
        const offsetTop = section.offsetTop - headerHeight;

        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    });
  });
});

//home : Our programmes.
document.addEventListener("DOMContentLoaded", function () {
  const colors = ["#FFE1C4", "#FFE192", "#FAC097", "#FFD666", "#D3D8EA"];
  const items = document.querySelectorAll(".our-program-card");
  if (items.length > 0) {
    items.forEach((item, index) => {
      const colorIndex = index % colors.length;
      item.style.backgroundColor = colors[colorIndex];
    });
  }
});

// education inner page
if (
  document.querySelector(".custom-header") &&
  document.querySelector(".custom-content")
) {
  const backgroundColors = [
    "#f58130",
    "#e9ebf5",
    "#fac097",
    "#ffd666",
    "#223c97",
  ];

  const textColors = ["#ffffff", "#333333", "#333333", "#333333", "#ffffff"];

  const svgFillColors = ["#ffffff", "#333333", "#333333", "#333333", "#ffffff"];

  const accordionItems = document.querySelectorAll(".accordion__item");

  accordionItems.forEach((item, index) => {
    item.querySelector(".custom-header").style.backgroundColor =
      backgroundColors[index % backgroundColors.length];
    item.querySelector(".custom-content").style.backgroundColor =
      backgroundColors[index % backgroundColors.length];

    item.querySelector(".custom-header").style.color =
      textColors[index % textColors.length];
    item.querySelector(".custom-content").style.color =
      textColors[index % textColors.length];

    // Apply fill color to the SVG path
    const svgPath = item.querySelector("svg path");
    if (svgPath) {
      svgPath.setAttribute("fill", svgFillColors[index % svgFillColors.length]);
    }
  });
}
